import { useDispatch, useSelector } from 'react-redux'

import type { AppDispatch, RootState } from '@store/store'

// Added Types for useDispatch, useSelector, useStore
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
// const useAppStore = useStore.withTypes<AppStore>()
